'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class Alerts {
  static displaySuccessSharingAlert(link) {
    FloatingAlertStore.addAlert({
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "slackUiLibrary.shareToSlackSidePanel.alerts.messageSharing.success.title"
      }),
      message: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "slackUiLibrary.shareToSlackSidePanel.alerts.messageSharing.success.message"
        }), /*#__PURE__*/_jsx(UIButton, {
          external: true,
          href: link,
          size: "extra-small",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "slackUiLibrary.shareToSlackSidePanel.alerts.messageSharing.success.viewInSlackButton"
          })
        })]
      }),
      type: 'success'
    });
  }
  static displayErrorAlert(id, title, message) {
    FloatingAlertStore.addAlert({
      id,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: title
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: message
      }),
      type: 'danger'
    });
  }
}
export default Alerts;